import React, {useLayoutEffect} from 'react';
import {Platform, View} from 'react-native';
import {Text} from '../../shared/components/text';
import Screen from '../../shared/components/screen';
import {useStyles} from '../../shared/hooks/styles';
import {datePipe} from '../../shared/pipes';
import {CustomScrollView} from '../../shared/components/scrollView';
import {LoadableContent} from '../../shared/components/loadableContent';
import {usePartialList} from '../../shared/hooks/usePartialList';
import {defaults} from '../../shared/constants/defaults';
import {useDispatch, useSelector} from 'react-redux';
import {dobroruDataLoadingSelector, dobroruDataSelector} from '../../redux/selectors/dobroru';
import {getDobroruData} from '../../redux/actions/dobroru';
import {profileHolderVolunteerIdSelector} from '../../redux/selectors/profile';
import {Button} from '../../shared/components/button';
import {images} from '../../assets/icons';

export const VolunteersServiceEventsScreen = () => {
  const styles = useStyles(({theme}) => ({
    root: {
      paddingTop: 16,
      paddingHorizontal: 16,
      paddingBottom: 32,
    },
    empty: {
      justifyContent: 'center',
      alignItems: 'center',
      paddingVertical: 24,
    },
    emptyText: {
      color: theme.color.gray500,
    },
    card: {
      borderRadius: 14,
      borderWidth: 1,
      borderColor: theme.color.gray300,
      marginBottom: 16,
      overflow: 'hidden',
    },
    name: {
      backgroundColor: theme.color.backgroundMenuColor,
      paddingVertical: 8,
      paddingHorizontal: 20,
    },
    info: {
      paddingVertical: 8,
      paddingHorizontal: 20,
      backgroundColor: theme.color.blue200,
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    infoDate: {
      color: theme.color.gray500,
    },
    loadMoreWrapper: {
      marginTop: 0,
      alignItems: 'center',
    },
    loadMoreButton: {
      borderWidth: 0,
      width: 180,
    },
  }));
  const volunteerId = useSelector(profileHolderVolunteerIdSelector);
  const dobroruData = useSelector(dobroruDataSelector);
  const dobroruDataLoading = useSelector(dobroruDataLoadingSelector);
  const [data, showMore, allShown] = usePartialList(dobroruData?.events ?? null, defaults.partialListSizeWithScroll);

  const dispatch = useDispatch();
  useLayoutEffect(() => {
    if (!dobroruData && volunteerId) dispatch(getDobroruData());
  }, [dobroruData, volunteerId]);

  return (
    <Screen>
      <CustomScrollView
        onEndReached={!allShown && Platform.OS !== 'web' ? showMore : undefined}
        contentInsetAdjustmentBehavior='automatic'
        contentContainerStyle={styles.root}>
        <LoadableContent loading={dobroruDataLoading}>
          {!data || !data.length ? (
            <View style={styles.empty}>
              <Text type='h5Light' style={styles.emptyText}>
                Список мероприятий пуст
              </Text>
            </View>
          ) : (
            <>
              {data?.map(({name, date, eventHours}, index) => {
                return (
                  <View style={styles.card} key={index}>
                    <View style={styles.name}>
                      <Text type='body'>{name}</Text>
                    </View>
                    <View style={styles.info}>
                      <Text type='bodySmallLight' style={styles.infoDate}>
                        {datePipe(date)}
                      </Text>
                      <Text type='action'>{eventHours} ч.</Text>
                    </View>
                  </View>
                );
              })}
              {Platform.OS === 'web' && !allShown ? (
                <View style={styles.loadMoreWrapper}>
                  <Button
                    id='notifications-more'
                    onPress={showMore}
                    style={styles.loadMoreButton}
                    text='Показать еще'
                    type='transparent'
                    icon={images.ChevronDown}
                    iconProps={{width: 24, height: 24}}
                  />
                </View>
              ) : null}
            </>
          )}
        </LoadableContent>
      </CustomScrollView>
    </Screen>
  );
};
